<template>
  <v-card>
    <v-card-title>
      Withdrawals
      <v-chip class="ml-2" small v-if="total">
        {{ total }}
      </v-chip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="withdrawals"
      :loading="loading"
      :server-items-length="total"
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      @update:page="getWithdrawals"
      @update:items-per-page="getWithdrawals"
      @click:row="openWithdrawal"
    >
      <template #[`item.amount`]="{ item }">
         {{ item.amount }}
      </template>
      <template #[`item.status`]="{ item }">
          <v-chip small :color="item.status ? item.status.color : 'grey'">
              {{ item.status ? item.status.label : 'Unknown' }}
          </v-chip>
      </template>
      <template #[`item.created_at`]="{ item }">
        {{ formatDate(item.created_at) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onMounted, computed, watch } from '@vue/composition-api'
import { formatDate } from '@core/date/dateFunctions'

export default {
  name: 'PartnerWithdrawalList',
  props: {
    partnerId: {
      type: [Number, String],
      required: true
    }
  },
  setup(props) {
    const loading = ref(false)
    const page = ref(1)
    const itemsPerPage = ref(10)

    const headers = [
      { text: 'Amount', value: 'amount' },
      { text: 'Status', value: 'status' },
      { text: 'Date', value: 'created_at' },
    ]

    const withdrawals = computed(() => store.getters['withdraw/withdraws'])
    const total = computed(() => store.getters['withdraw/total'])

    const getWithdrawals = () => {
      loading.value = true
      store.dispatch('withdraw/getWithdrawalsList', {
        page: page.value,
        field: {
          paginate: itemsPerPage.value,
          partner_id: props.partnerId
        }
      }).then(() => {
        loading.value = false
      })
    }

    const openWithdrawal = (item) => {
        router.push({ name: 'withdrawal-details', params: { id: item.id } })
    }

    watch(() => props.partnerId, () => {
        getWithdrawals()
    })

    onMounted(getWithdrawals)

    return {
      headers,
      withdrawals,
      total,
      loading,
      page,
      itemsPerPage,
      getWithdrawals,
      openWithdrawal,
      formatDate
    }
  }
}
</script>
